/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line
  // Sunkissed: place the product info column at half the centring offset (desktop)
  function skCentreHalf(){
    var col=document.querySelector('.product__page .product__content'); if(!col||window.innerWidth<750) return;
    col.style.justifyContent='flex-start'; col.style.paddingTop='24px';
    var inner=0; Array.prototype.forEach.call(col.children,function(ch){inner+=ch.getBoundingClientRect().height;});
    var free=window.innerHeight-inner-48; var pad=free>0?Math.round(free/4):0;
    col.style.paddingTop=(24+pad)+'px';
  }
  // Runs once on load and on resize; no timer re-runs (avoids post-load jumps).
  ['DOMContentLoaded','load'].forEach(function(ev){(ev==='DOMContentLoaded'?document:window).addEventListener(ev,skCentreHalf);});
  var skResizeT; window.addEventListener('resize',function(){clearTimeout(skResizeT);skResizeT=setTimeout(skCentreHalf,120);});
  document.addEventListener('sk:set:ready',function(){setTimeout(skCentreHalf,50);});
  // 1 · photo counter (mobile slider)
  function skCounter(){
    var slides=document.querySelector('.product__page .product__slides'); if(!slides||slides.dataset.skCounter) return;
    var items=slides.querySelectorAll('.product__slide'); if(items.length<2) return;
    slides.dataset.skCounter='1';
    var box=document.createElement('span'); box.className='sk-counter'; (slides.parentNode||slides).appendChild(box);
    function upd(){ var w=items[0].getBoundingClientRect().width+ (parseFloat(getComputedStyle(items[0]).marginRight)||0); var i=Math.round(slides.scrollLeft/Math.max(w,1)); box.textContent=(Math.min(i,items.length-1)+1)+' / '+items.length; }
    slides.addEventListener('scroll',upd,{passive:true}); upd();
  }
  // 6 · delivery date: order by 2pm ET, ships same/next business day, arrives +3 business days
  function skDelivery(){
    var el=document.querySelector('.product__page .sk-delivery'); var sh=document.querySelector('.product__page .sk-delivery-short'); if(!el) return;
    // Sunkissed (Oct 6): preorder variants show the ship date from theme.strings.preOrder instead of an arrival estimate
    var vid=(document.querySelector('.product__page input[name="id"][form]')||{}).value, pre=false;
    try{ pre=JSON.parse(document.querySelector('[data-variant-metafields]').textContent).some(function(x){return String(x.variant_id)===String(vid)&&x.preorder==='true';}); }catch(e){}
    if(pre){ var ps=(((window.theme&&window.theme.strings&&window.theme.strings.preOrder)||'').split('·')[1]||'').trim()||'Ships by Oct 16'; if(el.textContent!==ps) el.textContent=ps; if(sh&&sh.textContent!==ps) sh.textContent=ps; return; }
    var now=new Date(); var et=new Date(now.toLocaleString('en-US',{timeZone:'America/New_York'}));
    var ship=new Date(et); if(et.getHours()>=14) ship.setDate(ship.getDate()+1); while(ship.getDay()===0||ship.getDay()===6) ship.setDate(ship.getDate()+1);
    var arr=new Date(ship); var n=0; while(n<3){ arr.setDate(arr.getDate()+1); if(arr.getDay()!==0&&arr.getDay()!==6) n++; }
    var d=arr.toLocaleDateString('en-US',{weekday:'short',month:'short',day:'numeric'});
    var sameDay=et.getHours()<14 && et.getDay()!==0 && et.getDay()!==6;
    // estimate only — carriers can run late, so never promise a date
    var lt=(sameDay?'Order by 2pm ET · estimated arrival ':'Estimated arrival ')+d, st='Est. arrival '+d;
    if(el.textContent!==lt) el.textContent=lt; if(sh&&sh.textContent!==st) sh.textContent=st;
  }
  // 7 · sticky bar shows the chosen size
  function skBarSize(){
    var t=document.querySelector('.cart-bar .cart-bar__product__title'); if(!t) return;
    var size=null; document.querySelectorAll('.product__page .radio__legend').forEach(function(l){var n=l.querySelector('.radio__legend__option-name');if(n&&/size/i.test(n.textContent)){var v=l.querySelector('.radio__legend__value');if(v)size=v.textContent.trim();}});
    var base=t.getAttribute('data-sk-base')||t.textContent.split(' - ')[0].trim(); t.setAttribute('data-sk-base',base);
    var setTxt='';
    if(window.skSetPair&&window.skSetPair.isOn()){var ms=window.skSetPair.matchSize();var mp=window.skSetPair.matchPiece();if(ms&&mp) setTxt='<span class="sk-bar-size sk-bar-size--set">+ '+mp.charAt(0).toUpperCase()+mp.slice(1)+' '+ms+'</span>';}
    t.innerHTML=base+(size?'<span class="sk-bar-size">Size '+size+'</span>':'')+setTxt;
  }
  // One pass on ready, then only when the product column changes or the set toggle moves (no fixed timers).
  function skEnhance(){skCounter();skDelivery();skBarSize();skFitLine();}
  document.addEventListener('DOMContentLoaded',skEnhance);
  document.addEventListener('theme:variant:change',function(){setTimeout(function(){skDelivery();skBarSize();skFitLine();},80);});
  ['sk:set:change','sk:set:ready'].forEach(function(ev){document.addEventListener(ev,function(){setTimeout(skBarSize,30);});});
  document.addEventListener('change',function(e){if(e.target&&e.target.matches&&e.target.matches('[data-sk-match-size]')) setTimeout(skBarSize,30);});
  (function(){
    var col=document.querySelector('.product__page .product__content'); if(!col||!window.MutationObserver) return;
    var t; new MutationObserver(function(){clearTimeout(t);t=setTimeout(skEnhance,60);}).observe(col,{childList:true,subtree:true});
  })();
  // Sunkissed: italicise "first set" in the popup title; never show the popup on cart/checkout or while the bag is open
  function skPopupTitle(){document.querySelectorAll('.modal--newsletter .modal__title').forEach(function(h){if(h.dataset.sk)return;h.dataset.sk='1';h.innerHTML=h.innerHTML.replace(/first set/i,'<span class="sk-it">first set</span>');});}
  document.addEventListener('DOMContentLoaded',skPopupTitle);setTimeout(skPopupTitle,1200);
  if(/\/cart|\/checkouts?/.test(location.pathname)){var ov=document.querySelector('.modal__overlay--newsletter');if(ov)ov.remove();}
  // Sunkissed: move the fit line onto the Size row (right‑aligned)
  // Sunkissed 2a: fit note sits under both size rows, with a Size guide link on the same line
  function skFitLine(){
    var page=document.querySelector('.product__page'); if(!page||page.querySelector('.sk-fit-row')) return;
    var txt=page.querySelector('.product__text:not(.sk-moved) .product__subheading p');
    var sets=page.querySelectorAll('.radio__fieldset:not(.radio__fieldset--swatches)');
    var last=null; sets.forEach(function(f){ if(f.querySelector('.radio__button')&&f.offsetParent!==null) last=f; });
    if(!txt||!last) return;
    var row=document.createElement('div'); row.className='sk-fit-row';
    var note=document.createElement('span'); note.className='sk-fit-line'; note.innerHTML=txt.innerHTML; row.appendChild(note);
    var guide=page.querySelector('details.sk-acc:has(.sk-sz)')||Array.prototype.find.call(page.querySelectorAll('details'),function(d){return /size guide/i.test((d.querySelector('summary')||{}).textContent||'');});
    if(guide){
      var a=document.createElement('button'); a.type='button'; a.className='sk-fit-guide'; a.textContent='Size guide';
      a.addEventListener('click',function(){ guide.open=true; var y=guide.getBoundingClientRect().top+window.pageYOffset-90; window.scrollTo({top:y,behavior:'smooth'}); });
      row.appendChild(a);
    }
    last.insertAdjacentElement('afterend',row);
    page.querySelectorAll('.radio__legend .sk-fit-line').forEach(function(s){ s.remove(); });
    var block=txt.closest('.product__text'); if(block) block.classList.add('sk-moved');
  }
  // (skFitLine runs from skEnhance above)

  // CRO build: "Notify me" links from the grid open the back-in-stock popup on arrival
  if(/[?&]notify=1/.test(location.search)&&document.querySelector('.product__page')){
    var skNotifyTries=0;
    (function skOpenNotify(){
      var b=document.querySelector('.product__page .product-soldout-notification [data-popup-open]');
      if(b){b.click();return;}
      var f=document.querySelector('.product__page .sk-bis-inline input[type="email"]');
      if(f&&f.offsetParent){window.scrollTo({top:f.getBoundingClientRect().top+window.scrollY-200});f.focus({preventScroll:true});return;}
      if(++skNotifyTries<20) setTimeout(skOpenNotify,250);
    })();
  }
  // CRO build: newsletter tiles hide once someone has signed up (any theme newsletter form)
  // Hide newsletter blocks for 30 days after a signup. ?sk_show_nl=1 forces them back (for testing);
  // ?sk_reset_nl=1 clears the memory.
  function skHideNewsletter(){
    if(/sk_reset_nl=1/.test(location.search)){ try{localStorage.removeItem('sk_subscribed');}catch(e){} }
    if(/sk_show_nl=1/.test(location.search)) return;
    var v=null; try{ v=localStorage.getItem('sk_subscribed'); }catch(e){}
    if(!v) return;
    var t=parseInt(v,10); if(v==='1') t=Date.now();
    if(Date.now()-t < 30*24*60*60*1000) document.documentElement.classList.add('sk-subscribed');
    else { try{localStorage.removeItem('sk_subscribed');}catch(e){} }
  }
  skHideNewsletter();
  // Own validation on submit (no browser bubbles while typing). The signup is remembered only once
  // it actually passes validation; before, a typo'd attempt was enough to hide every newsletter block for 30 days.
  document.addEventListener('submit',function(e){
    var f=e.target; if(!f||!f.matches) return;
    var isSk=f.matches('[data-sk-newsletter-form]');
    var isNl=isSk||(f.matches('form[action*="/contact"]')&&!!f.querySelector('input[name="contact[email]"]'));
    if(!isNl) return;
    var em=f.querySelector('input[type="email"]');
    if(isSk&&em){
      var v=(em.value||'').trim();
      var err=f.querySelector('.sk-nl__err');
      if(!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v)){
        e.preventDefault(); e.stopImmediatePropagation();
        if(!err){ err=document.createElement('p'); err.className='sk-nl__err'; (em.closest('.sk-nl__row')||em.closest('.sk-nl__inline')||em).insertAdjacentElement('afterend',err); }
        err.textContent='Please enter a valid email'; em.focus();
        return;
      }
      if(err) err.remove();
    }
    try{localStorage.setItem('sk_subscribed',String(Date.now()));}catch(err2){}
  },true);
  // On the page that shows the thank-you, remember the signup but do NOT hide the block yet
  if(/customer_posted=true/.test(location.search)){ try{localStorage.setItem('sk_subscribed',String(Date.now()));}catch(err){} document.documentElement.classList.remove('sk-subscribed'); }

  // CRO build: grid tile size chips -> customer tag (top-S)
  document.addEventListener('click',function(e){
    var chip=e.target&&e.target.closest&&e.target.closest('[data-sk-chip]'); if(!chip) return;
    var form=chip.closest('form'); if(!form) return;
    form.querySelectorAll('[data-sk-chip]').forEach(function(c){var on=c===chip;c.classList.toggle('is-selected',on);c.setAttribute('aria-pressed',on?'true':'false');});
    var tags=form.querySelector('[data-sk-tags]'); if(tags) tags.value='newsletter, size-'+chip.getAttribute('data-sk-chip');
    var em=form.querySelector('input[type="email"]'); if(em) em.focus();
  });
  // CRO build: ticket sizes -> customer tags; thank-you applies the code to this session
  document.addEventListener('change',function(e){
    var sel=e.target; if(!sel||!sel.matches||!sel.matches('[data-sk-size]')) return;
    var form=sel.closest('form'); var tags=form&&form.querySelector('[data-sk-tags]'); if(!tags) return;
    var parts=['newsletter']; form.querySelectorAll('[data-sk-size]').forEach(function(s){ if(s.value) parts.push(s.getAttribute('data-sk-size')+'-'+s.value); });
    tags.value=parts.join(', ');
  });
  // Remember the code and carry it into checkout (?discount=CODE) so it is applied even if the cookie did not stick
  (function(){
    var code=null; try{ code=localStorage.getItem('sk_code'); }catch(e){}
    if(!code) return;
    document.addEventListener('click',function(e){
      var t=e.target&&e.target.closest&&e.target.closest('button[name="checkout"], .cart__checkout, a[href*="/checkout"], [data-checkout-button]'); if(!t) return;
      var href=t.getAttribute&&t.getAttribute('href');
      if(href&&/\/checkout/.test(href)&&!/discount=/.test(href)){ e.preventDefault(); location.href=href+(href.indexOf('?')>-1?'&':'?')+'discount='+encodeURIComponent(code); return; }
      if(t.matches('button[name="checkout"], .cart__checkout, [data-checkout-button]')){ e.preventDefault(); e.stopImmediatePropagation(); location.href='/checkout?discount='+encodeURIComponent(code); }
    },true);
  })();
  (function(){
    var done=document.querySelector('[data-sk-ticket-done]'); if(!done) return;
    try{ localStorage.setItem('sk_code',done.getAttribute('data-sk-code')||''); }catch(e){}
    var code=done.getAttribute('data-sk-code'); if(!code) return;
    try{ if(!sessionStorage.getItem('sk_code_applied')){ fetch('/discount/'+encodeURIComponent(code),{credentials:'same-origin'}).catch(function(){}); sessionStorage.setItem('sk_code_applied','1'); } }catch(err){}
    if(window.scrollTo){ var y=done.getBoundingClientRect().top+window.pageYOffset-120; if(y>0) window.scrollTo({top:y}); }
  })();
  // CRO build: collection filters start collapsed on phones (desktop keeps them open)
  function skMobileFilters(){
    if(window.innerWidth>=750) return;
    var btn=document.querySelector('.collection__nav .popout__toggle--filters[aria-expanded="true"]');
    if(btn){ btn.click(); }
  }
  if(document.readyState!=='loading') skMobileFilters(); else document.addEventListener('DOMContentLoaded',skMobileFilters);
  // Sunkissed: mirror the theme's live price into the title row
  function skMirrorPrice(){
    var src=document.querySelector('.product__page .sk-price-block [data-product-price]');
    var cmp=document.querySelector('.product__page .sk-price-block [data-compare-price]');
    var dst=document.querySelector('.product__page [data-sk-price]');
    var dstc=document.querySelector('.product__page [data-sk-compare]');
    if(src&&dst){dst.textContent=src.textContent.trim();}
    if(dstc){dstc.textContent=cmp?cmp.textContent.trim():'';}
  }
  document.addEventListener('DOMContentLoaded',skMirrorPrice);
  document.addEventListener('theme:variant:change',function(){setTimeout(skMirrorPrice,60);});
  var skSrc=document.querySelector('.product__page .sk-price-block');
  if(skSrc&&window.MutationObserver){new MutationObserver(skMirrorPrice).observe(skSrc,{childList:true,subtree:true,characterData:true});}


  




  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();

/* Sunkissed (Oct 13): bag bottom row. The Apple Pay / Google Pay column next to Checkout only shows once one of
   them has really drawn a button (a browser without either wallet keeps Checkout full width). CSS: sk-fixes-oct07b.css #26 */
(function () {
  function ready(w) {
    /* Apple Pay draws its button out of reach of the page, so ask Safari directly whether Apple Pay can be used here */
    if (w.tagName === 'SHOPIFY-APPLE-PAY-BUTTON') {
      try { if (window.ApplePaySession && window.ApplePaySession.canMakePayments() && w.getBoundingClientRect().height >= 20) return true; } catch (e) {}
    }
    if (w.childElementCount > 0 && w.getBoundingClientRect().height >= 30) return true;
    var els = w.querySelectorAll('*');
    for (var i = 0; i < els.length; i++) { var r = els[i].getBoundingClientRect(); if (r.height >= 30 && r.width >= 60) return true; }
    return false;
  }
  function check() {
    document.querySelectorAll('cart-drawer .additional-checkout-buttons').forEach(function (box) {
      var acc = box.querySelector('shopify-accelerated-checkout-cart'), hit = null;
      box.querySelectorAll('shopify-apple-pay-button, shopify-google-pay-button').forEach(function (w) { if (!hit && ready(w)) hit = w; });
      if (box.classList.contains('sk-wallet-ready') !== !!hit) box.classList.toggle('sk-wallet-ready', !!hit);
      if (acc) {
        var shift = hit ? Math.round(hit.getBoundingClientRect().top - acc.getBoundingClientRect().top) : 0;
        var mt = shift ? (-shift) + 'px' : '';
        if (acc.style.marginTop !== mt) acc.style.marginTop = mt;
      }
    });
  }
  var t;
  function soon() { clearTimeout(t); t = setTimeout(check, 200); }
  function start() { check(); new MutationObserver(soon).observe(document.body, { childList: true, subtree: true }); }
  if (document.readyState !== 'loading') start(); else document.addEventListener('DOMContentLoaded', start);
})();

/* Oct 13 2026: "Buy now" under Add to bag on the desktop product page (option B on the design page).
   It presses the real Add to bag, so the size rules ("Pick top size" etc.) and the "Make it a set"
   panel behave exactly as they do today. Once the theme confirms the add, the shopper goes straight
   to checkout, where Shopify shows Shop Pay / Apple Pay / Google Pay at the top.
   If a size is still missing, the usual size prompt shows and Buy now simply resets. */
(function () {
  'use strict';
  var going = null; // {btn, add, t0, busySeen}

  function addFor(btn) {
    var page = btn.closest('.product__page') || document;
    return page.querySelector('form[action*="/cart/add"] [data-add-to-cart]');
  }
  function busy(add) { return !!add && (add.disabled || add.classList.contains('is-loading')); }
  function waitingForSize(add) {
    return add.classList.contains('sk-btn-wait') || /^\s*pick\b/i.test(add.textContent || '');
  }

  function sync() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-sk-buy-now]'), function (b) {
      if (going && going.btn === b) return;
      var add = addFor(b);
      if (!add) { b.hidden = true; return; }
      var soldOut = add.disabled && !add.classList.contains('is-loading') && /sold\s*out|unavailable/i.test(add.textContent || '');
      b.hidden = soldOut;
      b.classList.toggle('is-wait', waitingForSize(add));
    });
  }

  function finish(ok) {
    if (!going) return;
    var g = going; going = null;
    clearInterval(g.timer);
    if (ok) {
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      g.btn.querySelector('.btn__text').textContent = 'Going to checkout';
      window.location.href = root + 'checkout';
      return;
    }
    g.btn.classList.remove('is-loading');
    g.btn.disabled = false;
    sync();
  }

  document.addEventListener('click', function (e) {
    var b = e.target && e.target.closest && e.target.closest('[data-sk-buy-now]');
    if (!b) return;
    e.preventDefault();
    if (going) return;
    var add = addFor(b);
    if (!add || add.disabled) return;
    going = {btn: b, add: add, t0: Date.now(), busySeen: false};
    b.classList.add('is-loading');
    b.disabled = true;
    add.click();
    // Watch the real button: busy = the add is on its way. Never busy = a size rule stopped it.
    going.timer = setInterval(function () {
      if (!going) return;
      var g = going, el = Date.now() - g.t0;
      if (busy(g.add)) { g.busySeen = true; return; }
      if (!g.busySeen && el > 350) return finish(false);
      if (g.busySeen && !g.doneAt) g.doneAt = Date.now();
      if (g.doneAt && Date.now() - g.doneAt > 1500) return finish(false); // add ended without success (error shown)
      if (el > 15000) finish(false);
    }, 60);
  });

  // The theme fires this on the Add to bag button right after a successful add
  document.addEventListener('theme:product:add', function (e) {
    if (!going) return;
    var src = e.target;
    if (src === going.add || (src && src.closest && going.add.closest('.product__page') === src.closest('.product__page'))) finish(true);
  }, true);

  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    going = null;
    Array.prototype.forEach.call(document.querySelectorAll('[data-sk-buy-now]'), function (b) {
      b.classList.remove('is-loading');
      b.disabled = false;
      var t = b.querySelector('.btn__text'); if (t) t.textContent = 'Buy now';
    });
    sync();
  });

  function start() {
    var adds = [];
    Array.prototype.forEach.call(document.querySelectorAll('[data-sk-buy-now]'), function (b) {
      var a = addFor(b); if (a && adds.indexOf(a) < 0) adds.push(a);
    });
    if (!adds.length) return;
    var t = null;
    var mo = new MutationObserver(function () { clearTimeout(t); t = setTimeout(sync, 50); });
    adds.forEach(function (a) { mo.observe(a, {attributes: true, attributeFilter: ['disabled', 'class'], childList: true, subtree: true, characterData: true}); });
    document.addEventListener('theme:variant:change', function () { setTimeout(sync, 80); });
    sync();
  }
  if (document.readyState !== 'loading') start(); else document.addEventListener('DOMContentLoaded', start);
})();


/* Oct 13 2026 (bag bottom, option B): the bag total sits inside Check out. The theme refreshes the
   price rows on every bag change but never re-draws the button, so copy the new total in each time. */
(function () {
  'use strict';
  function sync() {
    var drawer = document.querySelector('cart-drawer'); if (!drawer) return;
    var out = drawer.querySelector('[data-sk-co-total]'); if (!out) return;
    var tot = drawer.querySelector('[data-cart-price-holder] [data-cart-total]'); if (!tot) return;
    var cents = parseInt(tot.getAttribute('data-cart-total'), 10);
    var text = (tot.textContent || '').trim().replace(/\s+[A-Z]{3}$/, '');
    if (!/\d/.test(text) && window.theme && typeof window.theme.formatMoney === 'function' && !isNaN(cents)) {
      text = window.theme.formatMoney(cents, window.theme.moneyFormat);
    }
    out.textContent = text;
    out.hidden = !(cents > 0);
    var btn = out.closest('.cart__checkout');
    if (btn) btn.classList.toggle('sk-long', text.length > 8);
  }
  document.addEventListener('theme:cart:change', function () { setTimeout(sync, 0); });
  if (document.readyState !== 'loading') sync(); else document.addEventListener('DOMContentLoaded', sync);
})();
